/**
 * Safe JSON parsing utilities for handling content that may be string or object.
 * Prevents JSON.parse errors when API returns pre-parsed objects or invalid JSON.
 */

/**
 * Safely parse content that could be a JSON string or already an object.
 * Returns null by default on parse error, or caller-provided fallback.
 *
 * @param content - Content to parse (string, object, null, or undefined)
 * @param fallback - Optional fallback returned when content is null or parse fails
 * @returns Parsed object, original object, fallback, or null
 */
export function safeParseJSON<T = Record<string, unknown>>(content: unknown, fallback: T | null = null): T | null {
    if (content == null) return fallback
    if (typeof content === 'object') return content as T
    if (typeof content !== 'string') return content as T
    try {
        return JSON.parse(content) as T
    } catch {
        return fallback
    }
}
